import classes from './Typography.module.css.mjs';

const typographySizeClasses = {
  "display-l": classes.typographySizeDisplayL,
  "display-m": classes.typographySizeDisplayM,
  "paragraph-small": classes.typographySizeSmall,
  "paragraph-medium": classes.typographySizeMedium,
  "paragraph-large": classes.typographySizeLarge,
  h1: classes.typographySizeH1,
  h2: classes.typographySizeH2,
  h3: classes.typographySizeH3,
  h4: classes.typographySizeH4,
  h5: classes.typographySizeH5,
  h6: classes.typographySizeH6,
  "title-l": classes.typographySizeTitleL,
  "title-m": classes.typographySizeTitleM,
  "title-s": classes.typographySizeTitleS,
  "label-regular-xl": classes.typographySizeLabelRegularXL,
  "label-regular-l": classes.typographySizeLabelRegularL,
  "label-regular-m": classes.typographySizeLabelRegularM,
  "label-regular-s": classes.typographySizeLabelRegularS,
  "label-regular-xs": classes.typographySizeLabelRegularXS,
  "label-medium-xl": classes.typographySizeLabelMediumXL,
  "label-medium-l": classes.typographySizeLabelMediumL,
  "label-medium-m": classes.typographySizeLabelMediumM,
  "label-medium-s": classes.typographySizeLabelMediumS,
  "label-medium-xs": classes.typographySizeLabelMediumXS,
  "label-bold-l": classes.typographySizeLabelBoldL,
  "label-bold-m": classes.typographySizeLabelBoldM,
  "label-bold-s": classes.typographySizeLabelBoldS,
  "button-xl": classes.typographySizeButtonXL,
  "button-l": classes.typographySizeButtonL,
  "button-m": classes.typographySizeButtonM,
  "button-s": classes.typographySizeButtonS,
  "caption-m": classes.typographySizeCaptionM,
  "caption-s": classes.typographySizeCaptionS,
  "tag-m": classes.typographySizeTagM,
  "tag-s": classes.typographySizeTagS,
  overline: classes.typographySizeOverline,
  "navigation-brand-switcher": classes.typographySizeNavigationBrandSwitcher,
  "navigation-overlay-title": classes.typographySizeNavigationOverlayTitle,
  "navigation-overlay-item-l": classes.typographySizeNavigationOverlayItemL,
  "navigation-overlay-item-m": classes.typographySizeNavigationOverlayItemM,
  "navigation-overlay-item-s": classes.typographySizeNavigationOverlayItemS,
  "navigation-overlay-item-m-regular": classes.typographySizeNavigationOverlayItemMRegular,
  "navigation-overlay-item-m-bold": classes.typographySizeNavigationOverlayItemMBold,
  "navigation-overlay-category": classes.typographySizeNavigationOverlayCategory,
  "navigation-l": classes.typographySizeNavigationL,
  "navigation-m": classes.typographySizeNavigationM,
  "navigation-s": classes.typographySizeNavigationS,
  "navigation-selected": classes.typographySizeNavigationSelected,
  "navigation-unselected": classes.typographySizeNavigationUnselected
};

export { typographySizeClasses };
